import { BiPencil, BiTrash } from "react-icons/bi";
import { FaCopy, FaRegEye } from "react-icons/fa";
import { IoLink } from "react-icons/io5";
import { MdOutlineClose, MdPeople } from "react-icons/md";

export const Icons = {
  Delete: BiTrash,
  Edit: BiPencil,
  Remove: MdOutlineClose,
  Clone: FaCopy,
  View: FaRegEye,
  Share: MdPeople,
  Link: IoLink,
};
